import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import SEO from '../SEO';
import { FileText } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Términos y Condiciones"
        description="Términos y condiciones de uso de la plataforma asisant."
        canonical="/terminos"
      />
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-dark-ellipse">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/10 mb-6">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Términos y Condiciones
          </h1>
          <p className="text-white/80">
            Última actualización: Enero 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Aceptación de los Términos</h2>
            <p className="text-[#c3c3c5] mb-6">
              Al acceder y utilizar la plataforma Asisant, usted acepta estar vinculado por estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al servicio.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Descripción del Servicio</h2>
            <p className="text-[#c3c3c5] mb-6">
              Asisant es una plataforma de comercio cloud que permite a distribuidores IT, MSPs y operadores de telecomunicaciones gestionar suscripciones, automatizar facturación y ofrecer servicios cloud a sus clientes. El servicio incluye marketplace, gestión de contratos, facturación automatizada e integraciones con proveedores cloud.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Registro y Cuenta</h2>
            <p className="text-[#c3c3c5] mb-4">Para utilizar nuestros servicios, usted debe:</p>
            <ul className="list-disc pl-6 text-[#c3c3c5] space-y-2 mb-6">
              <li>Proporcionar información precisa y completa durante el registro</li>
              <li>Mantener la seguridad de su cuenta y contraseña</li>
              <li>Notificarnos inmediatamente de cualquier uso no autorizado</li>
              <li>Ser responsable de todas las actividades realizadas bajo su cuenta</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Uso Aceptable</h2>
            <p className="text-[#c3c3c5] mb-4">Usted se compromete a no utilizar el servicio para:</p>
            <ul className="list-disc pl-6 text-[#c3c3c5] space-y-2 mb-6">
              <li>Violar cualquier ley o regulación aplicable</li>
              <li>Infringir derechos de propiedad intelectual de terceros</li>
              <li>Transmitir malware o código malicioso</li>
              <li>Interferir con la operación del servicio</li>
              <li>Acceder a sistemas o datos sin autorización</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Facturación y Pagos</h2>
            <p className="text-[#c3c3c5] mb-6">
              Los precios y condiciones de pago se establecen en el acuerdo de servicio correspondiente. Los pagos son no reembolsables excepto según lo especificado en el acuerdo. Nos reservamos el derecho de modificar los precios con previo aviso de 30 días.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Propiedad Intelectual</h2>
            <p className="text-[#c3c3c5] mb-6">
              Todo el contenido, características y funcionalidad de la plataforma son propiedad exclusiva de Asisant y están protegidos por leyes de propiedad intelectual. No se le otorga ningún derecho de propiedad intelectual sobre el servicio más allá de lo necesario para utilizarlo.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Disponibilidad del Servicio</h2>
            <p className="text-[#c3c3c5] mb-6">
              Nos esforzamos por mantener un uptime del 99.9%. Sin embargo, el servicio puede experimentar interrupciones por mantenimiento programado o circunstancias fuera de nuestro control. Notificaremos con anticipación cualquier mantenimiento planificado.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Limitación de Responsabilidad</h2>
            <p className="text-[#c3c3c5] mb-6">
              En la máxima medida permitida por la ley, Asisant no será responsable por daños indirectos, incidentales, especiales o consecuentes que resulten del uso o la incapacidad de usar el servicio.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Indemnización</h2>
            <p className="text-[#c3c3c5] mb-6">
              Usted acepta indemnizar y mantener indemne a Asisant de cualquier reclamación, daño o gasto que surja de su uso del servicio o violación de estos términos.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Terminación</h2>
            <p className="text-[#c3c3c5] mb-6">
              Podemos suspender o terminar su acceso al servicio inmediatamente, sin previo aviso, por cualquier razón, incluyendo el incumplimiento de estos términos. Tras la terminación, su derecho a usar el servicio cesará inmediatamente.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">11. Modificaciones</h2>
            <p className="text-[#c3c3c5] mb-6">
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor al ser publicados en la plataforma. El uso continuado del servicio después de cualquier modificación constituye la aceptación de los nuevos términos.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">12. Ley Aplicable</h2>
            <p className="text-[#c3c3c5] mb-6">
              Estos términos se regirán e interpretarán de acuerdo con las leyes aplicables, sin tener en cuenta sus disposiciones sobre conflictos de leyes.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">13. Contacto</h2>
            <p className="text-[#c3c3c5] mb-6">
              Para cualquier pregunta sobre estos Términos y Condiciones, puede contactarnos en:
            </p>
            <div className="bg-[#e3e4e6]/30 rounded-2xl p-6">
              <p className="text-gray-900 font-medium">Asisant</p>
              <p className="text-[#1297fd]">info@asisant.com</p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;
